import axios from "axios";
import { useMainContext } from "../contexts/main";

const useSetAxiosHeaders = () => {

    const { profile: { token }, main: { lang } } = useMainContext()

    axios.defaults.headers['x-auth-token'] = token
    axios.defaults.headers['Accept-Language'] = lang
}


export {
    useSetAxiosHeaders
}
